<template>
  <div class="quote-component tva-row">
    <div :class="['quote', 'tva-col-md-offset-2 tva-col-md-8 tva-col-sm-offset-2 tva-col-sm-8 tva-col-xs-12', {'active': active}]">
      <span>{{content}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content", "active"]
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
.quote-component {
  padding: 50px 0;
  .quote {
    span {
      background: white;
      transition: all 1s ease;
    }
    &.active span {
      background: $terna-light-blu;
    }
  }
}
@media (max-width: 768px) {
  .quote-component {
    padding: 0 15px;
  }
}
</style>
